import { API_MAP, agent } from 'helpers';

class SubscriptionsService {
  static listMySubscriptions(filters: any, pagination: any) {
    //exportParam = `&export=1`;
    return agent.get(API_MAP.listSubscriptions, { ...filters, ...pagination });
  }
  static listMySubscriptionsInvoices(subscriptionId: number) {
    return agent.get(`${API_MAP.listSubscriptionsInvoices}`.replace('{id}', `${subscriptionId}`));
  }
  static getPostbackInvoices(subscriptionId: number, invoiceId: number) {
    return agent.get(`${API_MAP.listPostbackInvoices}`.replace('{id}', `${subscriptionId}`).replace('{invoice_id}', `${invoiceId}`));
  }
  static cancelSubscription(subscriptionId: number, motive: string) {
    return agent.post(`${API_MAP.cancelSubscription}`.replace('{id}', `${subscriptionId}`), { motive });
  }
  static reactivateSubscription(subscriptionId: number, motive: string) {
    return agent.post(`${API_MAP.reactivateSubscription}`.replace('{id}', `${subscriptionId}`), { motive });
  }
  static cancelSubscriptionAgend(subscriptionId: number, motive: string, date_cancel: string) {
    return agent.post(`${API_MAP.cancelSubscription}`.replace('{id}', `${subscriptionId}`), { motive, date_cancel });
  }
  static getNextToken() {
    return agent.post(`${API_MAP.getNextToken}`, {});
  }
  static suspendSubscription(subscriptionId: number, motive: string) {
    return agent.post(`${API_MAP.suspendSubscription}`.replace('{id}', `${subscriptionId}`), { motive });
  }
  static listProducts() {
    return agent.get(`${API_MAP.listSubscriptionProducts}`);
  }
  static listStatus() {
    return agent.get(`${API_MAP.listSubscriptionStatus}`);
  }
  static newChargeInvoice(subscriptionId: number, invoiceId: number) {
    return agent.post(`${API_MAP.newChargeInvoice}`.replace('{id}', `${subscriptionId}`).replace('{invoice_id}', `${invoiceId}`), {});
  }
  static changePaymentBankslip(subscriptionId: number) {
    return agent.post(`${API_MAP.changePaymentBankslip}`.replace('{id}', `${subscriptionId}`), {});
  }
  static getContractData(subscriptionId: number) {
    return agent.get(`${API_MAP.getSubscriptions}`.replace('{id}', `${subscriptionId}`), {});
  }

  static addAffiliate(id: number, email: string) {
    return agent.post(`${API_MAP.addAffiliate}`.replace('{id}', `${id}`), { affiliate_email: email });
  }

  static changeChargeEmail(id: number, email: string) {
    return agent.post(`${API_MAP.changeChargeEmail}`.replace('{id}', `${id}`), { charge_email: email });
  }

  static setNewDueDate(contract: number, invoiceId: number, newDueDate: string) {
    return agent.post(`${API_MAP.setNewDueDate}`.replace('{contract}', contract.toString()).replace('{invoiceId}', invoiceId.toString()), {
      due_date: newDueDate,
    });
  }

  static changePayment(contract: number, card: number) {
    return agent.post(`${API_MAP.changePayment.replace('{id}', contract.toString())}`, { payment_id: card });
  }

  static bankslip(url: string) {
    return agent.get(`${API_MAP.bankslip.replace('{hash}', url.toString())}`, {});
  }

  static saveNegotiateInvoices(subscription: any, invoices: any[]) {
    return agent.post(`${API_MAP.saveNegotiateInvoices}`.replace('{id}', `${subscription}`), { invoices });
  }
}

export default SubscriptionsService;
